import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Shield, Baby, Heart, Activity, Zap, Plus } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Shield,
  Baby,
  Heart,
  Activity,
  Zap,
  Plus
};

const Services = () => {
  return (
    <section id="leistungen" className="py-20 bg-gradient-to-br from-red-50 via-white to-red-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Unsere Leistungen
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Umfassende gynäkologische Betreuung mit modernster Diagnostik und 
            einfühlsamer Beratung für alle Lebensphasen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="bg-white/80 backdrop-blur-sm hover:shadow-xl transition-all duration-300 border-red-100 hover:border-red-200 group cursor-pointer"
              >
                <CardHeader className="text-center pb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-red-100 to-red-200 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:from-red-200 group-hover:to-red-300 transition-all duration-300">
                    <IconComponent className="h-8 w-8 text-red-600" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-gray-900 group-hover:text-red-700 transition-colors duration-300">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 text-center leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-red-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Haben Sie Fragen zu unseren Leistungen?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Gerne beraten wir Sie persönlich zu unserem Behandlungsspektrum und 
              finden gemeinsam die passende Betreuung für Sie.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => document.getElementById('kontakt').scrollIntoView({ behavior: 'smooth' })}
                className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-6 py-3 rounded-lg font-medium transition-all duration-300 hover:shadow-lg"
              >
                Beratung anfragen
              </button>
              <button
                onClick={() => window.open('https://app.arzt-direkt.de/frauenarzt-praxis-gronau/booking', '_blank')}
                className="border border-red-300 text-red-700 hover:bg-red-50 px-6 py-3 rounded-lg font-medium transition-all duration-300"
              >
                Termin vereinbaren
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;